import {TFunction} from 'i18next';

import {IBalanceItemMemberUI} from '../models/interfaces';

export const formatMembersSummary = (
  members: IBalanceItemMemberUI[],
  t: TFunction,
): string => {
  if (members.length === 0) return '';

  if (members.length === 1) {
    return members[0].name;
  }

  if (members.length === 2) {
    return `${members[0].name} ${t('common.and')} ${members[1].name}`;
  }

  const [first, ...rest] = members;

  return `${first.name} ${t('groups.dashboard.count_other_members', {
    count: rest.length,
  })}`;
};
